import { getSession } from '../services/register.js';
import { getUpdatedFiles } from '../services/pclab.js';
import { alertError, alertInfo } from '../utils/edittools.js';
import { responseCode, responseData } from '../types/domain.js';
import type { SoftwareFileMap } from '../types/domain.js';
import { isRecord } from './dva-types.js';
import type { ModelSaga, TypedModel } from './dva-types.js';

export interface PltState {
  readonly modalOpen?: boolean;
  readonly fileInfo?: SoftwareFileMap;
}

function isSessionWithServerTime(value: unknown): value is { serverTime?: number } {
  return (
    !(value instanceof Error) &&
    isRecord(value) &&
    (value['serverTime'] === undefined || typeof value['serverTime'] === 'number')
  );
}

const model: TypedModel<PltState> = {
  namespace: 'plt',
  state: {},
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname }) => {
        if (pathname !== '/plt' && pathname !== '/plt/') return;
        dispatch({ type: 'initialization' });
      });
    },
  },
  effects: {
    *initialization(_, { put }): ModelSaga {
      const session = yield getSession();
      const serverTime = isSessionWithServerTime(session) ? session.serverTime : undefined;
      if (serverTime !== undefined && Math.abs(Date.now() - serverTime) > 24 * 60 * 60 * 1000) {
        alertInfo('氦星人检测到您的计算机时间异常，可能影响系统正常使用，请您及时调整。');
      }
      const installerResponse = yield getUpdatedFiles({ appVersion: 'hxrInstaller' });
      const pltResponse = yield getUpdatedFiles({ appVersion: 'plt' });
      if (responseCode(installerResponse) !== 0) {
        alertError(
          installerResponse instanceof Error ? installerResponse.message : '获取最新版本失败',
        );
        return;
      }
      const fileInfo = responseData<SoftwareFileMap>(installerResponse);
      if (responseCode(pltResponse) === 0) {
        yield put({
          type: 'update',
          payload: { fileInfo: { ...fileInfo, ...responseData<SoftwareFileMap>(pltResponse) } },
        });
        return;
      }
      yield put({ type: 'update', payload: { fileInfo } });
    },
  },
  reducers: {
    update(state: PltState, { payload }: { payload: Partial<PltState> }): PltState {
      return { ...state, ...payload };
    },
  },
};

export default model;
